<template>
    <div class="module-layer4">
        <div class="layer-cnt">
            <div class="lr-nav">
                <div v-for="item in 4" :key="item" @click="handIdx(item)">
                    <img :src="iconActive == item ? require(`../../assets/img/layer4/nav/${item}-active.png`) : require(`../../assets/img/layer4/nav/${item}.png`)"
                        alt="" srcset="">
                </div>
            </div>
            <div class="nav-role-cnt">
                <div v-for="item in roleList">
                    <div v-if="iconActive == item.id" class="icon-item">
                        <swiper :options="roleOptions" ref="roleOptions" @slideChange="roleNavSlideChange">
                            <swiper-slide v-for="(iconItem, idx) in item.list" :key="idx">
                                <div class="iconItem" :class="'role-' + iconItem.id">
                                    
                                    <div class="role-txt">
                                        <img :src="iconItem.title" alt="" srcset="" class="role-title">
                                        <img src="../../assets/img/layer4/audio-btn.png" alt="" srcset=""
                                            class="audio-btn" :class="'role-' + iconItem.id + '-aduio'"  @click="handleAudio(iconItem)">
                                        <img :src="iconItem.info" alt="" srcset="" class="role-info">
                                    </div>
                                    <img :src="iconItem.roleIdx" alt="" srcset="" class="roleIdx">
                                    <img :src="iconItem.bg" alt="" srcset="" class="role-bg">
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                        <div class="swiper-pagination swiper-pagination-role cursor" :class="[
                            nextShow ? '' : 'swiperNoSwiping',
                            'roleIdx-' + iconActive
                        ]" slot="pagination"></div>
                        <!-- coming soon 按钮 -->
                        <div class="csoon-icon">
                            <img :src="require(`../../assets/img/layer4/role-${iconActive}/3.png`)" alt="" srcset="">
                            <img :src="require(`../../assets/img/layer4/role-${iconActive}/4.png`)" alt="" srcset="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    <!-- audio -->
    <audio controls="controls" ref="audio" id="nameAttrValue" style="display: none;">
      <source :src="musicUrl" type="audio/wav" />
    </audio>
    </div>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {
            musicUrl: '',
            activeIndex: 1,
            iconActive: 1,
            roleList: [
        {
          id: 1,
          list: [
            {
              idx: 1,
              id: 'r-1-1',
              title: require('../../assets/img/layer4/1-title.png'),
              info: require('../../assets/img/layer4/1-info.png'),
              bg: require('../../assets/img/layer4/1-bg.png'),
              roleIdx: require('../../assets/img/layer4/1.png'),
              audioSrc: require('../../assets/img/layer4/1-audio.wav')
            },
            {
              idx: 2,
              id: 'r-2-1',
              title: require('../../assets/img/layer4/2-title.png'),
              info: require('../../assets/img/layer4/2-info.png'),
              bg: require('../../assets/img/layer4/2-bg.png'),
              roleIdx: require('../../assets/img/layer4/2.png'),
              audioSrc: require('../../assets/img/layer4/2-audio.wav')

            }
          ]
        },
        {
          id: 2,
          list: [
            {
              idx: 1,
              id: 'r-1-2',
              title: require('../../assets/img/layer4/3-title.png'),
              info: require('../../assets/img/layer4/3-info.png'),
              bg: require('../../assets/img/layer4/3-bg.png'),
              roleIdx: require('../../assets/img/layer4/3.png'),
              audioSrc: require('../../assets/img/layer4/3-audio.wav')

            },
            {
              idx: 2,
              id: 'r-2-2',
              title: require('../../assets/img/layer4/4-title.png'),
              info: require('../../assets/img/layer4/4-info.png'),
              bg: require('../../assets/img/layer4/4-bg.png'),
              roleIdx: require('../../assets/img/layer4/4.png'),
              audioSrc: require('../../assets/img/layer4/4-audio.wav')

            }
          ]
        },
        {
          id: 3,
          list: [
            {
              idx: 1,
              id: 'r-1-3',
              title: require('../../assets/img/layer4/5-title.png'),
              info: require('../../assets/img/layer4/5-info.png'),
              bg: require('../../assets/img/layer4/5-bg.png'),
              roleIdx: require('../../assets/img/layer4/5.png'),
              audioSrc: require('../../assets/img/layer4/5-audio.wav')

            },
            {
              idx: 2,
              id: 'r-2-3',
              title: require('../../assets/img/layer4/6-title.png'),
              info: require('../../assets/img/layer4/6-info.png'),
              bg: require('../../assets/img/layer4/6-bg.png'),
              roleIdx: require('../../assets/img/layer4/6.png'),
              audioSrc: require('../../assets/img/layer4/6-audio.wav')

            }
          ]
        },
        {
          id: 4,
          list: [
            {
              idx: 1,
              id: 'r-1-4',
              title: require('../../assets/img/layer4/7-title.png'),
              info: require('../../assets/img/layer4/7-info.png'),
              bg: require('../../assets/img/layer4/7-bg.png'),
              roleIdx: require('../../assets/img/layer4/7.png'),
              audioSrc: require('../../assets/img/layer4/7-audio.wav')

            },
            {
              idx: 2,
              id: 'r-2-4',
              title: require('../../assets/img/layer4/8-title.png'),
              info: require('../../assets/img/layer4/8-info.png'),
              bg: require('../../assets/img/layer4/8-bg.png'),
              roleIdx: require('../../assets/img/layer4/8.png'),
              audioSrc: require('../../assets/img/layer4/8-audio.wav')

            }
          ]
        },
      ],
            nextShow: true,

            roleOptions: {
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                allowTouchMove: false,
                pagination: {
                    el: ".swiper-pagination-role",
                    touchRatio: 1, //解决滑动卡顿
                    longSwipesRatio: 0.1,
                    threshold: 10, //如果触摸距离小于该值滑块不会被拖动
                    followFinger: false,
                    bulletClass: "my-bullet", //需设置.my-bullet样式
                    clickable: true, // 允许点击小圆点跳转
                    autoplayDisableOnInteraction: false,

                    renderBullet: function (index, className) {
                        switch (index) {
                            case 0:
                                name = "";
                                break;
                            case 1:
                                name = "";
                                break;
                            case 2:
                                name = "";
                            case 3:
                                name = "";
                            default:
                                name = "";
                        }
                        return (
                            '<div class="' +
                            className +
                            " " +
                            className +
                            [index] +
                            '"><i>' +
                            name +
                            "</i></div>"
                        );
                    },

                },

                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

            },
        }
    },
    watch: {
    },
    methods: {
         // 滑动箭头的时候，音频不播放
    stopAduio() {
      let audio = this.$refs.audio;
      audio.pause();
    },
    handIdx(idx) {
      this.iconActive = idx
      this.stopAduio()
    },
    handleAudio(val) {
      this.$refs.audio.src = val.audioSrc;
      let audio = this.$refs.audio;
      audio.load();
      audio.play();
    },
    roleNavSlideChange() {
      this.stopAduio()
    }
    }
}
</script>
<style lang="scss">
.module-layer4 {
    width: 100%;
    height: 100%;
    position: relative;
    background: url('../../assets/img/layer4/bg.png') 50% no-repeat;
    background-size: cover;
    z-index: 0;
    .layer-cnt {
        width: 100%;
        height: 100%;

        .lr-nav {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: absolute;
            right: 0;
            top: 6%;
            transition: all .3s;
            z-index: 999;

            img {
                display: block;
                width: 206px;
                height: 126px;
                cursor: pointer;
            }
        }

        .iconItem {
            width: 100%;
            height: 100%;
            position: relative;

            .role-txt {
                position: absolute;
                left: 24px;
                top: 8%;

                img {
                    display: block;
                }

                .role-title {
                    width: 627px;
                    height: 166px;
                }

                .audio-btn {
                    width: 148px;
                    height: 47px;
                    margin: 48px 0 20px 0;
                }

                .role-info {
                    width: 558px;
                    height: 59px;
                }
            }

            .role-bg {
                width: 750px;
                height: 1500px;
                display: block;
            }

            .roleIdx {
                position: absolute;
                left: 50%;
                transform: translate(-50%, 0);
            }

        }

        // 每个角色背景尺寸
        // 根据ID来
        .role-r-1-1 {
            .roleIdx {
                width: 707px;
                height: 748px;
                bottom: 22%;
            }
        }

        .role-r-2-1 {
            .roleIdx {
                width: 746px;
                height: 681px;
                bottom:24%;
            }
        }

        .role-r-1-2 {
            .roleIdx {
                width: 750px;
                height: 699px;
                bottom: 23%;
            }
        }

        .role-r-2-2 {
            .roleIdx {
                width: 467px;
                height: 756px;
                bottom: 21%;
            }
        }

        .role-r-1-3 {
            .roleIdx {
                width: 750px;
                height: 721px;
                bottom: 21%;
            }
        }

        .role-r-2-3 {
            .roleIdx {
                width: 628px;
                height: 780px;
                bottom:18%;
            }
        }

        .role-r-1-4 {
            .roleIdx {
                width: 645px;
                height: 735px;
                bottom:21%;
            }
        }

        .role-r-2-4 {
            .roleIdx {
                width: 708px;
                height: 689px;
                bottom: 24%;
            }
        }

        // 菜单
        .swiper-button-prev:after {
            display: none;
        }

        .swiper-button-next:after {
            display: none;
        }

        .swiper-button-prev {
            background: url("../../assets/img/layer4/prev.png") no-repeat top;
            background-size: 100% 100%;
            width: 31px;
            height: 49px;
            bottom: 4%;
            left: 12%;
            top: auto;
        }

        .swiper-button-next {
            background: url("../../assets/img/layer4/next.png") no-repeat top;
            background-size: 100% 100%;
            width: 31px;
            height: 49px;
            bottom: 4%;
            top: auto;
            right: 12%;
        }

        .swiper-pagination-role {
            z-index: 3;
            transition: all 0.5s;
            z-index: 3;
            padding-left: 20%;
            bottom:2%;
            display: flex;
            align-items: center;
            // gap: 14px;

            .my-bullet {
                display: flex;
                justify-content: center;
                width: 93px;
                height: 93px;
                margin-right: 15px;
                i {
                    display: block;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                }
            }

            .swiper-pagination-bullet-active {
                background-color: transparent;
                width: 130px;
                height: 130px;
            }

        }

        .csoon-icon {
            position: absolute;
            bottom:3%;
            right: 17%;
            display: flex;
            justify-content: center;
            align-items: center;
            // gap: 14px;

            img {

                width: 93px;
                height: 93px;
                display: block;
                margin-right: 15px;

            }
        }

        .roleIdx-1 {
            .my-bullet0 i {
                background: url('../../assets/img/layer4/role-1/1.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet0.swiper-pagination-bullet-active i {
                background: url('../../assets/img/layer4/role-1/1-active.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet1 i {
                background: url('../../assets/img/layer4/role-1/2.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet1.swiper-pagination-bullet-active i {
                background: url('../../assets/img/layer4/role-1/2-active.png') no-repeat;
                background-size: 100% 100%;
            }
        }

        .roleIdx-2 {
            .my-bullet0 i {
                background: url('../../assets/img/layer4/role-2/1.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet0.swiper-pagination-bullet-active i {
                background: url('../../assets/img/layer4/role-2/1-active.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet1 i {
                background: url('../../assets/img/layer4/role-2/2.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet1.swiper-pagination-bullet-active i {
                background: url('../../assets/img/layer4/role-2/2-active.png') no-repeat;
                background-size: 100% 100%;
            }
        }

        .roleIdx-3 {
            .my-bullet0 i {
                background: url('../../assets/img/layer4/role-3/1.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet0.swiper-pagination-bullet-active i {
                background: url('../../assets/img/layer4/role-3/1-active.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet1 i {
                background: url('../../assets/img/layer4/role-3/2.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet1.swiper-pagination-bullet-active i {
                background: url('../../assets/img/layer4/role-3/2-active.png') no-repeat;
                background-size: 100% 100%;
            }
        }

        .roleIdx-4 {
            .my-bullet0 i {
                background: url('../../assets/img/layer4/role-4/1.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet0.swiper-pagination-bullet-active i {
                background: url('../../assets/img/layer4/role-4/1-active.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet1 i {
                background: url('../../assets/img/layer4/role-4/2.png') no-repeat;
                background-size: 100% 100%;
            }

            .my-bullet1.swiper-pagination-bullet-active i {
                background: url('../../assets/img/layer4/role-4/2-active.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }

}

@media screen and (min-width: 375px) and(max-width: 429px) and (orientation : portrait) {
    .module-layer4 {
        .lr-nav {
            img {
                width: 175px !important;
                height: 107px !important;
            }
        }

        .iconItem {
            .role-bg {
            }
            .role-txt {
                top: 8% !important;
            }

            .role-title {
                width: 533px !important;
                height: 141px !important;
            }

            .audio-btn {
                width: 133px !important;
                height: 42px !important;
                margin: 35px 0 15px 0 !important;
            }

            .role-info {
                width: 502px !important;
                height: 54px !important;
            }
        }

        .role-r-1-1 .roleIdx {
            bottom: 30% !important;
            // width: 600px !important;
            // height: 635px !important;
            width: 636px !important;
            height: 673px !important;
        }

        .role-r-2-1 .roleIdx {
            bottom: 32% !important;
            width: 671px !important;
            height: 612px !important;
            // width: 634px !important;
            // height: 579px !important;
        }

        .role-r-1-2 .roleIdx {
            bottom: 32% !important;
            width: 675px !important;
            height: 630px !important;
        }

        .role-r-2-2 .roleIdx {
            bottom: 29% !important;
            width: 420px !important;
            height: 680px !important;
        }

        .role-r-1-3 .roleIdx {
            bottom: 29% !important;
            width: 675px !important;
            height: 649px !important;
        }

        .role-r-2-3 .roleIdx {
            bottom: 27% !important;
            width: 565px !important;
            height: 702px !important;
        }

        .role-r-1-4 .roleIdx {
            bottom: 29% !important;
            width: 580px !important;
            height: 661px !important;
        }

        .role-r-2-4 .roleIdx {
            bottom: 32% !important;
            width: 637px !important;
            height: 620px !important;
        }

        .swiper-pagination-role {
            bottom:8% !important;
            padding-left:20% !important;

            .my-bullet {
                width: 92px !important;
                height: 92px !important;
            }

            .swiper-pagination-bullet-active {
                width: 117px !important;
                height: 117px !important;
            }
        }

        .swiper-button-next,
        .swiper-button-prev {
            bottom: 10% !important;
        }

        .swiper-button-next {
            right: 12% !important;
        }

        .swiper-button-prev {
            left: 12% !important;
        }

        .csoon-icon {
            bottom: 9% !important;
            right: 19.5% !important;

            img {
                width: 92px !important;
                height: 92px !important;
            }
        }
    }
}

@media screen and (min-width: 638px) and (max-width: 1024px) and (orientation : portrait) {
    .module-layer4 {
        .lr-nav {
            top: 10% !important;
            img {
                width: 148px !important;
                height: 90px !important;
            }
        }

        .iconItem {
           
            .role-txt {
                top: 7% !important;
            }

            .role-title {
                width: 453px !important;
                height: 120px !important;
            }

            .audio-btn {
                width: 113px !important;
                height: 36px !important;
                margin: 25px 0 10px 0 !important;
            }

            .role-info {
                width: 427px !important;
                height: 46px !important;
            }
        }

        .role-r-1-1 .roleIdx {
           
            bottom:45% !important;
            width: 513px !important;
            height: 543px !important;
        }

        .role-r-2-1 .roleIdx {
            bottom: 46% !important;
            width: 541px !important;
            height: 494px !important;
           
        }

        .role-r-1-2 .roleIdx {
            bottom:45% !important;
            width: 573px !important;
            height: 535px !important;
        }

        .role-r-2-2 .roleIdx {
            bottom: 43% !important;
            width: 340px !important;
            height: 550px !important;
        }

        .role-r-1-3 .roleIdx {
            bottom: 43% !important;
            width: 574px !important;
            height: 552px !important;
        }

        .role-r-2-3 .roleIdx {
            bottom: 42.5% !important;
            width: 480px !important;
            height: 597px !important;
        }

        .role-r-1-4 .roleIdx {
            bottom: 43% !important;
            width: 468px !important;
            height: 534px !important;
        }

        .role-r-2-4 .roleIdx {
            bottom: 46% !important;
            width: 514px !important;
            height: 500px !important;
        }

        .swiper-pagination-role {
            bottom: 5% !important;
            padding-left: 27% !important;

            .my-bullet {
                width: 70px !important;
                height: 70px !important;
                

            }

            .swiper-pagination-bullet-active {
                width: 89px !important;
                height: 89px !important;
            }
        }

        .swiper-button-next,
        .swiper-button-prev {
            bottom: 7% !important;
        }

        .swiper-button-next {
            right: 17% !important;
        }

        .swiper-button-prev {
            left: 18% !important;
        }

        .csoon-icon {
            bottom:6% !important;
            right: 25% !important;

            img {
                width: 70px !important;
                height: 70px !important;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/layer4.vue